import axios from 'axios';
import API_BASE from '../config';

const API_BASE_URL = API_BASE;

const api = {
  getReactions: async (page = 1, perPage = 20, typeFilter = '', seed = null) => {
    const params = { page, per_page: perPage };
    if (typeFilter) params.type = typeFilter;
    if (seed !== null) params.seed = seed;
    const response = await axios.get(`${API_BASE_URL}/reactions`, { params });
    return response.data;
  },

  getReaction: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/reactions/${id}`);
    return response.data;
  },

  getStats: async () => {
    const response = await axios.get(`${API_BASE_URL}/stats`);
    return response.data;
  }
};

export default api;
